import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ApiRequest } from "src/app/_models/common/request-response/api-request";
import { GradeService } from "src/app/_services";
import { LoggingPanelModel } from "../../../_models/common/LoggingPanelModel";
import { LogObjectActionTemplateEnum } from "../../../_models";
import { ClaimsService } from "../../../_services/common/claims.service";
import { LoggingPanelService } from "../../../_services/logging-panel/logging-panel.service";
import { Claims } from "../../../_models/common/claims";
import { Subscription } from "rxjs";
import { CountByStatus, GridConfig } from "src/app/_models/common/grid/grid-config";
import { ColDef } from "ag-grid-community";
import { NgOption } from "@ng-select/ng-select";
import { AppGridComponent } from "src/app/shared/grid/grid-component/grid.component";
import { BaseComponent } from "src/app/shared/base/base-component";
import { AlertService } from "src/app/alert-panel/alert.service";

@Component({
    selector: "grade-assign-category-panel",
    templateUrl: "./grade-assign-category-panel.component.html",
    standalone: false
})
export class GradeAssignCategoryPanelComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;

  @Output() closePanel = new EventEmitter<boolean>();
  @Input() selectedGrade: any = {};
  @Input() categoriesList: any = [];
  @Input() inputCategoriesList: any = [];

  alertSubscription: Subscription;
  claimsubscription: Subscription;
  claims: Claims;
  panelHeading: string;
  hasFormChanges: boolean = false;

  defaultSortColumn = 'categoryName';
  gridData: any[] = [];
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridFilterStatus: number = 0;
  gridFilterItems: NgOption[] = [
    { id: 0, name: this.translate.instant("all") },
    { id: 1, name: this.translate.instant("assigned_category_grade") },
    { id: 2, name: this.translate.instant("unassigned_category_grade") }
  ];

  currentEditingGrade: any;
  showCategoryAssignmentPanel: boolean;
  disableSave: boolean = true;
  isSaved: boolean = false;
  showNoCategorySelected: boolean = false;
  changedCategoryList: any[] = [];

  constructor(
    private gradeService: GradeService,
    private alertService: AlertService,
    private toastr: ToastrService,
    private claimsService: ClaimsService,
    private loggingPanelService: LoggingPanelService,
    private translate: TranslateService
  ) {
      super();
      this.claimsubscription = this.claimsService.currentClaims.subscribe(claims => {
        this.claims = claims;
      });
      var currentContext = this;
      this.alertSubscription = this.alertService.getUserActionEvent().subscribe((action) => {
        if (action) {
          currentContext.hasFormChanges = false;
          currentContext.fnClosePanel();
        }
      });
  }

  ngOnInit(): void {
    this.fnInitialiseGrid();
  }

  ngOnDestroy() {
    this.claimsubscription.unsubscribe();
    this.alertSubscription.unsubscribe();
  }

  ngOnChanges(changes) {
    if (this.selectedGrade) {
      this.panelHeading = this.selectedGrade.gradeName + ' ' + this.translate.instant('assign_unassign_categories_to_grade');

      for(let i =0;i<this.categoriesList.length;i++) {
        if(this.selectedGrade.categoriesIds.indexOf(this.categoriesList[i].categoryId) > -1) {
          this.categoriesList[i].selected = true;
        }
        else {
          this.categoriesList[i].selected = false;
        }
      }
      this.fnInitialiseCategoriesData();
      this.fnGridFilterChanged(this.gridFilterStatus);

    }
    else {
        this.panelHeading = '';
        this.gridData = [];
    }
    this.disableSave = true;
  }

  canDeactivate() {
    return !this.hasFormChanges;
  }

  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.AssignGradetoCategory.toString(),
      this.selectedGrade.gradeId
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
        this.gridComponent.initializeGrid();
    }, 100);
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
        {
            headerName: this.translate.instant('cc_dashboard_label_category_name'),
            field: 'categoryName',
            resizable: true,
            sortable: true,
            suppressHeaderMenuButton: true,
            minWidth: 100,
        }
    ];
  }

  fnGetGridConfigItems() {

    let filterClass = "d-inline-block cursor-pointer text-underline lH-12 ";

    let totalCategoryCount = this.categoriesList.length;
    let assignedCount = this.categoriesList.filter(r => r.selected).length;
    let unassignedCount = this.categoriesList.filter(r => !r.selected).length;

    let countByStatusArray = [];

    countByStatusArray.push(new CountByStatus("d-block", this.translate.instant('total_categories'), totalCategoryCount, false, 0));

    countByStatusArray.push(new CountByStatus(filterClass + "inactive-state padding-right-10 padding-left-10",
        this.translate.instant('all'), totalCategoryCount, true, 0));
    countByStatusArray.push(new CountByStatus(filterClass + "active-state padding-right-10 padding-left-10 border-left-2px",
        this.translate.instant('assigned_category_grade'), assignedCount, true, 1));
    countByStatusArray.push(new CountByStatus(filterClass + "not-invited-state padding-left-10 border-left-2px",
        this.translate.instant('unassigned_category_grade'), unassignedCount, true, 2));

    this.gridConfigItems = new GridConfig(
        false,
        true,
        this.defaultSortColumn,
        "categoryId",
        this.gridFilterStatus,
        true,
        countByStatusArray,
        true,
        true,
        true,
        null,
        'asc',
        40,
        'no_data_availabe',
        null,
        null,
        false, false,
        '',
        '',
        true
    );
  }

  fnOnGridCellClick(params) {
    switch (params.column.colId) {
        case 'selected': {
          // Track changes from the actual data state, not the DOM click target.
          // params.data.selected is the checkbox's current state (maintained by the
          // checkbox renderer + the shared grid, which only mutate it on a real
          // checkbox click). A category counts as "changed" only when its current
          // state differs from the originally-assigned state. This is robust
          // regardless of where inside the cell the click landed.
          const wasAssigned = this.selectedGrade.categoriesIds.indexOf(params.data.categoryId) > -1;
          const isNowSelected = !!params.data.selected;
          const trackedIndex = this.changedCategoryList.findIndex(c => c.categoryId == params.data.categoryId);

          if (isNowSelected !== wasAssigned) {
            if (trackedIndex === -1) {
              this.changedCategoryList.push(params.data);
            }
          }
          else if (trackedIndex > -1) {
            this.changedCategoryList.splice(trackedIndex, 1);
          }

          this.hasFormChanges = this.changedCategoryList.length > 0;
          this.disableSave = this.changedCategoryList.length === 0;
          break;
        }
    }
  }

  fnGridFilterChanged(status) {
    this.gridData = [];
    this.gridFilterStatus = status;
    switch (status) {
        case 0:
            this.gridData = this.categoriesList;
            break;
        case 1:
            this.gridData = this.categoriesList.filter(e => e.selected);
            break;
        case 2:
            this.gridData = this.categoriesList.filter(e => !e.selected);
            break;
    }
    this.fnGetGridConfigItems();

    if(this.gridComponent) {
      setTimeout(() => {
          this.gridComponent.refreshGridData();
      }, 100);
    }
  }

  saveAssignedGradeToCategoriesByGrade() {
    this.disableSave = true;

    if (this.categoriesList.filter(x => x.selected).length == 0) {
      this.showNoCategorySelected = true;
      return;
    }

    if (this.changedCategoryList.length == 0) {
      return;
    }

    const categoriesToGradeByGrade = [];
    for (let i = 0;i<this.changedCategoryList.length;i++) {
      categoriesToGradeByGrade.push({
        selected: this.changedCategoryList[i].selected,
        gradeId: this.selectedGrade.gradeId,
        gradeName: this.selectedGrade.gradeName,
        orgExpenseCategoryId: this.changedCategoryList[i].categoryId,
        orgExpenseCategoryName: this.changedCategoryList[i].categoryName
      });
    }

    let getCategpriesToGradeByGradeSaveRequest = new ApiRequest<any>(
      "SoloSaveOrgAssignCategoryToGradesByGrade",
      1.0,
      "111"
    );
    getCategpriesToGradeByGradeSaveRequest.requestInfo = categoriesToGradeByGrade;

    this.gradeService.saveCategpriesToGradeByGrade(getCategpriesToGradeByGradeSaveRequest).subscribe((data) => {
      this.toastr.success(this.translate.instant("success"));
      this.isSaved = true;
      this.hasFormChanges = false;
      this.changedCategoryList = [];
      this.fnClosePanel();
    });
  }

  fnClosePanel() {
    if (this.canDeactivate()) {
        this.closePanel.emit(this.isSaved);
        this.isSaved = false;
        this.disableSave = true;
        this.changedCategoryList = [];
    }
    else {
        this.alertService.onFormClosed();
    }
  }

  closeNoCategorySelected() {
    this.showNoCategorySelected = false;
  }

  fnOnGridCheckAll(isChecked) {
    this.changedCategoryList = [];

    for (let i = 0;i<this.gridData.length;i++) {
      if(!(this.inputCategoriesList.find(c => c.categoryId == this.gridData[i].categoryId) && 
      this.inputCategoriesList.find(c => c.categoryId == this.gridData[i].categoryId)?.selected == isChecked))
      {
        this.changedCategoryList.push(this.gridData[i]);
      }
    }
    this.disableSave = false;
    this.hasFormChanges = true;
  }

  fnInitialiseCategoriesData(){
    this.inputCategoriesList = [];
    for(let i=0; i< this.categoriesList.length;i++)
    {
      this.inputCategoriesList.push({
        selected: this.categoriesList[i].selected,
        categoryId: this.categoriesList[i].categoryId,
        categoryName: this.categoriesList[i].categoryName
      });
    }
  }

}
